import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center justify-center relative overflow-hidden min-h-[60vh]" data-id="element-13">
      {/* Abstract futuristic cityscape — CSS-generated */}
      <div className="absolute inset-0 z-0 overflow-hidden opacity-20" data-id="element-14">
        {/* Vertical "building" lines */}
        <div className="absolute bottom-0 left-[10%] w-px h-[45%] bg-gradient-to-t from-brand-gold/30 to-transparent" data-id="element-15" />
        <div className="absolute bottom-0 left-[12%] w-[3px] h-[60%] bg-gradient-to-t from-brand-gold/20 to-transparent" data-id="element-16" />
        <div className="absolute bottom-0 left-[20%] w-[2px] h-[50%] bg-gradient-to-t from-brand-gold/25 to-transparent" data-id="element-17" />
        <div className="absolute bottom-0 left-[22%] w-px h-[70%] bg-gradient-to-t from-brand-gold/15 to-transparent" data-id="element-18" />
        <div className="absolute bottom-0 left-[30%] w-[4px] h-[55%] bg-gradient-to-t from-brand-gold/20 to-transparent" data-id="element-19" />
        <div className="absolute bottom-0 left-[35%] w-px h-[40%] bg-gradient-to-t from-brand-gold/30 to-transparent" data-id="element-20" />
        <div className="absolute bottom-0 left-[45%] w-[2px] h-[65%] bg-gradient-to-t from-brand-gold/15 to-transparent" data-id="element-21" />
        <div className="absolute bottom-0 left-[48%] w-px h-[50%] bg-gradient-to-t from-brand-gold/25 to-transparent" data-id="element-22" />
        <div className="absolute bottom-0 left-[55%] w-[3px] h-[75%] bg-gradient-to-t from-brand-gold/20 to-transparent" data-id="element-23" />
        <div className="absolute bottom-0 left-[60%] w-px h-[45%] bg-gradient-to-t from-brand-gold/30 to-transparent" data-id="element-24" />
        <div className="absolute bottom-0 left-[68%] w-[2px] h-[55%] bg-gradient-to-t from-brand-gold/20 to-transparent" data-id="element-25" />
        <div className="absolute bottom-0 left-[72%] w-px h-[65%] bg-gradient-to-t from-brand-gold/15 to-transparent" data-id="element-26" />
        <div className="absolute bottom-0 left-[78%] w-[4px] h-[50%] bg-gradient-to-t from-brand-gold/25 to-transparent" data-id="element-27" />
        <div className="absolute bottom-0 left-[85%] w-px h-[60%] bg-gradient-to-t from-brand-gold/20 to-transparent" data-id="element-28" />
        <div className="absolute bottom-0 left-[90%] w-[2px] h-[45%] bg-gradient-to-t from-brand-gold/30 to-transparent" data-id="element-29" />

        {/* Horizontal glow at the horizon */}
        <div className="absolute bottom-[30%] left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/20 to-transparent" data-id="element-30" />
        <div className="absolute bottom-[30%] left-[15%] right-[15%] h-[2px] blur-sm bg-brand-gold/10" data-id="element-31" />
      </div>

      {/* Top and bottom fade */}
      <div className="absolute inset-0 z-[1] bg-gradient-to-b from-brand-dark via-transparent to-brand-dark pointer-events-none" data-id="element-32" />

      <div className="w-full max-w-4xl text-center relative z-10" data-id="element-33">
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-heading text-xl sm:text-2xl md:text-4xl text-brand-offWhite leading-relaxed font-light tracking-wide" data-id="element-34">
          We partner with ideas, operators, and projects positioned at the edge
          of culture and technology.
        </motion.p>
      </div>
    </section>;
}